/**
 * The icon for thumbs Up.
 * https://www.figma.com/design/LHoF60AgvlnXcwv25cns5j/ARTICLE-PAGE--WEB---APP-?node-id=6292-50060&m=dev
 */
const IconThumbsDown = () => {
  return (
    <path
      d="M3.77219 14.45C4.20219 14.96 4.82219 15.25 5.49219 15.25L9.52219 15.25L9.52219 18C9.52219 19.52 10.7522 20.75 12.3522 20.75C13.0522 20.75 13.6822 20.33 13.9622 19.68L16.5022 13.75L18.3722 13.75C19.6822 13.75 20.7422 12.69 20.7422 11.38L20.7422 5.61C20.7422 4.31 19.6722 3.25 18.3722 3.25L6.81219 3.25C5.72219 3.25 4.79219 4.03 4.60219 5.11L3.28219 12.61C3.17219 13.27 3.35219 13.94 3.78219 14.45L3.77219 14.45ZM18.3722 4.75C18.8522 4.75 19.2422 5.14 19.2422 5.61L19.2422 11.38C19.2422 11.86 18.8522 12.25 18.3722 12.25L16.7622 12.25L16.7622 4.75L18.3722 4.75ZM6.07219 5.37C6.13219 5.01 6.44219 4.75 6.81219 4.75L15.2522 4.75L15.2522 12.85L12.5822 19.1C12.5422 19.19 12.4522 19.26 12.2622 19.26C11.5722 19.26 11.0222 18.7 11.0222 18.01L11.0222 13.76L5.49219 13.76C5.26219 13.76 5.06219 13.67 4.92219 13.5C4.78219 13.33 4.72219 13.11 4.76219 12.88L6.08219 5.38L6.07219 5.37Z"
      fill="currentColor"
      data-icon="icon-thumbs-down"
    />
  );
};

export default IconThumbsDown;
